  /* eslint-disable */
import { createApp } from 'vue'
import Maska from 'maska'
import money from 'v-money3'
import router from './router'
import App from './App.vue'
import store from './store/store';
  import VueMobileDetection from "vue-mobile-detection";
  import 'hacktimer'

import VueSmoothScroll from 'vue3-smooth-scroll'
import VueCodeHighlight from 'vue-code-highlight';

const app = createApp(App);  
app.use(VueCodeHighlight).use(router).use(store).use(Maska).use(money).use(VueSmoothScroll).use(VueMobileDetection).mount('#app')
app.config.globalProperties.console = console
app.config.globalProperties.window = window


app.config.globalProperties.$router = router;


import "bootstrap/js/dist/popover.js"
import "bootstrap/dist/js/bootstrap.js"
import "@/assets/scss/fonts.scss"

